/** @format */

import React, { Component } from 'react';
import { Modal, Form, Icon, Header, Divider } from 'semantic-ui-react';

import { inject, observer } from 'mobx-react';

@inject('ClientsStore')
@observer
class ClientAddressEdit extends Component {
  render() {
    const { ClientsStore } = this.props;
    return (
      <Modal
        onClose={() => {
          ClientsStore.toggleAddressForm();
          ClientsStore.resetCurrentAddress();
        }}
        open={ClientsStore.clientsParams.clientAddressForm.open}
      >
        <Modal.Content>
          <Header className="modal-header" as="h3">
            <small>
              <Icon name="marker" />
            </small>
            Modifica Indirizzo
          </Header>
          <div className="header-spacer"></div>
          <Form
            className="modal-form"
            size="small"
            onSubmit={() => ClientsStore.handleAddressSubmit()}
          >
            <Form.Group widths="equal">
              <Form.Input
                name="address"
                value={ClientsStore.currentAddress.data.address}
                onChange={(e, input) =>
                  ClientsStore.handleEditAddress(input.name, input.value)
                }
                fluid
                label="address"
                placeholder="Via o Piazza e numero civico"
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Input
                name="address2"
                value={ClientsStore.currentAddress.data.address2}
                onChange={(e, input) =>
                  ClientsStore.handleEditAddress(input.name, input.value)
                }
                fluid
                label="address2"
                placeholder="Scala, Interno"
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Input
                name="zip"
                value={ClientsStore.currentAddress.data.zip}
                onChange={(e, input) =>
                  ClientsStore.handleEditAddress(input.name, input.value)
                }
                fluid
                label="zip"
                placeholder="CAP"
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Input
                name="city"
                value={ClientsStore.currentAddress.data.city}
                onChange={(e, input) =>
                  ClientsStore.handleEditAddress(input.name, input.value)
                }
                fluid
                label="city"
                placeholder="Città"
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Input
                name="country"
                value={ClientsStore.currentAddress.data.country}
                onChange={(e, input) =>
                  ClientsStore.handleEditAddress(input.name, input.value)
                }
                fluid
                label="country"
                placeholder="Nazione"
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.TextArea
                name="notes"
                value={ClientsStore.currentAddress.data.notes}
                onChange={(e, input) =>
                  ClientsStore.handleEditAddress(input.name, input.value)
                }
                label="notes"
                placeholder="notes"
              />
            </Form.Group>
            <Divider />
            <Form.Button color="green" type="submit" fluid size="small">
              <Icon name="save" /> Salva Indirizzo
            </Form.Button>
          </Form>
          <div
            className="close-button"
            onClick={() => {
              ClientsStore.toggleAddressForm();
              ClientsStore.resetCurrentAddress();
            }}
          >
            X
          </div>
        </Modal.Content>
      </Modal>
    );
  }
}

export default ClientAddressEdit;
